import {
  Box,
  Dialog,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Button,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
} from "@material-ui/core";
import Axios from "axios";
import React, { useEffect, useState, Fragment } from "react";
import Notify from "src/notification/Notify";
import FormvalidatorHemothology from "./validation/FormvalidatorHemothology";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import HemathologyRef from "../references/Ref_Hemathology";
import DraggableDialog from "src/utils/DraggableDialog";
import { useHistory } from "react-router-dom";
import { CheckSquare, XCircle } from "react-feather";

const OrderDetails = ({ order, getLabHemaOrder, resetDisplay }) => {
  const token = localStorage.getItem("token");
  const user_id = localStorage.getItem("user_id");
  const username = localStorage.getItem("username");

  const history = useHistory();
  const [orderDetails, setOrderDetails] = useState({
    data: [],
    ready: false,
  });

  const [pendingDialog, setPendingDialog] = useState(false);
  const [processDialog, setProcessDialog] = useState({
    open: false,
    data: null,
  });

  const [pendingSubmitting, setPendingSubmitting] = useState(false);
  const [processSubmitting, setProcessSubmitting] = useState(false);
  const [resultSubmitting, setResultSubmitting] = useState(false);
  const saveButtonRef = React.useRef();
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [savebtnDisabled, setSavebtnDisabled] = useState(true);

  const getLabOrderDetails = () => {
    var formdata = new FormData();
    formdata.set("token", token);
    formdata.set("user_id", user_id);
    formdata.set("trace_number", order.trace_number);
    Axios.post("laboratory/order/ordernew-hemathology/details", formdata)
      .then((response) => {
        const data = response.data;
        setOrderDetails({
          data: data,
          ready: true,
        });

        checkIfSaveBtnIsEnabled(data);
      })
      .catch((error) => {
        Notify.requestError(error);
      });
  };

  const checkIfSaveBtnIsEnabled = (data) => {
    for (let i = 0; i < data.length; i++) {
      if (Boolean(data[i].is_processed)) {
        setSavebtnDisabled(false);
      }
    }
  };

  useEffect(() => {
    getLabOrderDetails();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order]);

  const handleSaveResult = (e) => {
    e.preventDefault();
    e.persist();

    var formdata = new FormData(e.target);
    formdata.set("token", token);
    formdata.set("user_id", user_id);
    formdata.set("trace_number", order.trace_number);

    var error = [];

    if (orderDetails.data) {
      error = FormvalidatorHemothology(orderDetails.data, formdata);
    }

    if (error.length > 0) {
      console.log("Form has an error.");
    } else {
      setResultSubmitting(true);
      Axios.post(
        "laboratory/order/ordernew-hemathology/save-process-result",
        formdata
      )
        .then((response) => {
          const data = response.data;
          if (data === "success") {
            Notify.successRequest("order result added. Redirect to receipt.");
            setTimeout(() => {
              history.push(
                `/clinic/app/laboratory/record/print/order/${order.trace_number}`
              );
            }, 5000);
          }
        })
        .catch((error) => {
          Notify.requestError(error);
        });
    }
  };

  const handlePendingOrder = (e) => {
    e.preventDefault();
    e.persist();

    var formdata = new FormData(e.target);
    formdata.set("token", token);
    formdata.set("user_id", user_id);
    formdata.set("username", username);
    formdata.set("trace_number", order.trace_number);

    var error = [];

    if (error.length > 0) {
      console.log("Form has an error.");
    } else {
      setPendingSubmitting(true);
      Axios.post(
        "laboratory/order/ordernew-hemathology/save-setpending",
        formdata
      )
        .then((response) => {
          const data = response.data;
          if (data === "pass-invalid") {
            Notify.fieldInvalid("password");
          }
          if (data === "success") {
            getLabHemaOrder();
            resetDisplay();
            setPendingDialog(false);
            Notify.successRequest("order pending");
          }
        })
        .catch((error) => {
          Notify.requestError(error);
        })
        .finally(() => setPendingSubmitting(false));
    }
  };

  const handleProcessOrder = (e) => {
    e.preventDefault();
    e.persist();

    var formdata = new FormData(e.target);
    formdata.set("token", token);
    formdata.set("user_id", user_id);
    formdata.set("username", username);
    formdata.set("order_id", processDialog.data.order_id);

    var error = [];

    if (error.length > 0) {
      console.log("Form has an error.");
    } else {
      setProcessSubmitting(true);
      Axios.post(
        "laboratory/order/ordernew-hemathology/save-setprocessing",
        formdata
      )
        .then((response) => {
          const data = response.data;
          if (data === "pass-invalid") {
            Notify.fieldInvalid("password");
          }
          if (data === "success") {
            getLabOrderDetails();
            setProcessDialog({ open: false, data: null });
            Notify.successRequest("order pending");
          }
        })
        .catch((error) => {
          Notify.requestError(error);
        })
        .finally(() => setProcessSubmitting(false));
    }
  };

  return (
    <>
      <form onSubmit={handleSaveResult}>
        <Card elevation={0}>
          <CardHeader
            component={Box}
            align="center"
            title={
              <Box>
                <Typography variant="h5">
                  <b> LABORATORIO MEDICO DE CALIDAD </b>
                </Typography>
                <Typography>With</Typography>
                <Typography variant="h6">
                  <b> DR. MELY R. PENAFLORIDA-LASTIMOSO MD FPSV </b>
                </Typography>
              </Box>
            }
            subheader={`General Medicine & Treats SEXUALLY TRANSMITTED DISEASES Including HIV & AIDS and other venereal diseases
                        2/F Room 4&5 VENCER building National Highway 
                         General Santos City`}
          />
          <CardContent>
            {/* paitent information */}
            <Box display="flex">
              <Box flexGrow={1} mb={2}>
                <Box mb={2}>
                  <Typography>
                    <Typography variant="caption" className="font-weight-bold">
                      NAME:
                    </Typography>{" "}
                    {`${order.firstname} ${order.lastname}`}
                  </Typography>
                </Box>

                <Box display="flex" mb={2}>
                  <Box>
                    <Typography>
                      <Typography
                        variant="caption"
                        className="font-weight-bold"
                      >
                        AGE:
                      </Typography>{" "}
                      {order.birthday === null
                        ? "none"
                        : Notify.calculateAge(order.birthday)}
                    </Typography>
                  </Box>
                  <Box ml={5}>
                    <Typography>
                      <Typography
                        variant="caption"
                        className="font-weight-bold"
                      >
                        SEX:
                      </Typography>{" "}
                      {order.gender === null ? "none" : order.gender}
                    </Typography>
                  </Box>
                </Box>

                <Box>
                  <Typography>
                    <Typography variant="caption" className="font-weight-bold">
                      ADDRESS:
                    </Typography>{" "}
                    {`${order.street} ${order.barangay} ${order.city} ${order.zip} `}
                  </Typography>
                </Box>
              </Box>

              <Box>
                <Box mb={2}>
                  <Typography>
                    <Typography variant="caption" className="font-weight-bold">
                      DATE:
                    </Typography>{" "}
                    {Notify.dateTimeConvert(new Date().toLocaleString())}
                  </Typography>
                </Box>
                {/* <Box mb={2} display="flex" >   
                                    <Box flexGrow={1}>
                                        <Typography variant="caption" className="font-weight-bold">
                                            COMPANY:
                                        </Typography> 
                                    </Box> 
                                    <TextField label={''} margin="dense" /> 
                                </Box>  */}
              </Box>
            </Box>
          </CardContent>

          <CardContent>
            {/* order details */}
            <Box>
              <Typography variant="h6" align="center">
                <b> HEMATOLOGY </b>
              </Typography>
            </Box>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell />
                    <TableCell align="center">
                      <b> RESULT </b>
                    </TableCell>
                    <TableCell align="center">
                      <b> REFERENCE VALUES </b>
                    </TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {orderDetails.ready ? (
                    orderDetails.data.length > 0 ? (
                      orderDetails.data.map((data, key) => (
                        <Fragment key={key}>
                          <TableRow
                            hidden={!Boolean(data.hemoglobin === "new-order")}
                          >
                            <TableCell>
                              <Typography
                                variant="subtitle2"
                                className={`gtc-uppercase`}
                              >
                                hemoglobin
                              </Typography>
                            </TableCell>
                            <TableCell align="center">
                              {/* hidden inputs */}
                              <Box>
                                <TextField
                                  margin="dense"
                                  fullWidth
                                  name="order_id[]"
                                  label="order_id"
                                  hidden
                                  value={data.order_id}
                                />
                                <TextField
                                  margin="dense"
                                  fullWidth
                                  name="patient_id"
                                  label="patient_id"
                                  hidden
                                  value={data.patient_id}
                                />

                                <TextField
                                  margin="dense"
                                  fullWidth
                                  name="doctors_id"
                                  label="doctor_id"
                                  hidden
                                  value={
                                    data.doctor_id === null
                                      ? ""
                                      : data.doctor_id
                                  }
                                />
                              </Box>

                              <Box>
                                <TextField
                                  margin="dense"
                                  fullWidth
                                  // required
                                  name="hemoglobin[]"
                                  label="Result"
                                  type="number"
                                  InputProps={{
                                    inputProps: {
                                      min: 1,
                                      max: 1000,
                                      step: 0.01,
                                    },
                                  }}
                                  disabled={
                                    !Boolean(parseInt(data.is_processed))
                                  }
                                />
                              </Box>
                            </TableCell>
                            <TableCell align="center">
                              <Box> {HemathologyRef.hemoglobin()} </Box>
                            </TableCell>
                            <TableCell>
                              <Button
                                disabled={Boolean(parseInt(data.is_processed))}
                                size="small"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  setProcessDialog({
                                    data: data,
                                    open: true,
                                  });
                                }}
                              >
                                Process
                              </Button>
                            </TableCell>
                          </TableRow>

                          <TableRow
                            hidden={!Boolean(data.hematocrit === "new-order")}
                          >
                            <TableCell>
                              <Typography
                                variant="subtitle2"
                                className={`gtc-uppercase`}
                              >
                                hematocrit
                              </Typography>
                            </TableCell>
                            <TableCell align="center">
                              <Box>
                                <TextField
                                  margin="dense"
                                  // required
                                  fullWidth
                                  name="hematocrit[]"
                                  label="Result"
                                  type="number"
                                  InputProps={{
                                    inputProps: {
                                      min: 0.01,
                                      max: 1000,
                                      step: 0.01,
                                    },
                                  }}
                                  disabled={
                                    !Boolean(parseInt(data.is_processed))
                                  }
                                />
                              </Box>
                            </TableCell>
                            <TableCell align="center">
                              <Box> {HemathologyRef.hematocrit()} </Box>
                            </TableCell>
                            <TableCell>
                              <Button
                                disabled={Boolean(parseInt(data.is_processed))}
                                size="small"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  setProcessDialog({
                                    data: data,
                                    open: true,
                                  });
                                }}
                              >
                                Process
                              </Button>
                            </TableCell>
                          </TableRow>

                          <TableRow hidden={!Boolean(data.rbc === "new-order")}>
                            <TableCell>
                              <Typography
                                variant="subtitle2"
                                className={`gtc-uppercase`}
                              >
                                RBC
                              </Typography>
                            </TableCell>
                            <TableCell align="center">
                              <Box>
                                <TextField
                                  margin="dense"
                                  // required
                                  fullWidth
                                  name="rbc[]"
                                  label="Result"
                                  type="number"
                                  InputProps={{
                                    inputProps: {
                                      min: 1,
                                      max: 1000,
                                      step: 0.01,
                                    },
                                  }}
                                  disabled={
                                    !Boolean(parseInt(data.is_processed))
                                  }
                                />
                              </Box>
                            </TableCell>
                            <TableCell align="center">
                              <Box>{HemathologyRef.rbc()}</Box>
                            </TableCell>
                            <TableCell>
                              <Button
                                disabled={Boolean(parseInt(data.is_processed))}
                                size="small"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  setProcessDialog({
                                    data: data,
                                    open: true,
                                  });
                                }}
                              >
                                Process
                              </Button>
                            </TableCell>
                          </TableRow>

                          <TableRow hidden={!Boolean(data.wbc === "new-order")}>
                            <TableCell>
                              <Typography
                                variant="subtitle2"
                                className={`gtc-uppercase`}
                              >
                                wbc
                              </Typography>
                            </TableCell>
                            <TableCell align="center">
                              <Box>
                                <TextField
                                  margin="dense"
                                  // required
                                  fullWidth
                                  name="wbc[]"
                                  label="Result"
                                  type="number"
                                  InputProps={{
                                    inputProps: {
                                      min: 1,
                                      max: 1000,
                                      step: 0.01,
                                    },
                                  }}
                                  disabled={
                                    !Boolean(parseInt(data.is_processed))
                                  }
                                />
                              </Box>
                            </TableCell>
                            <TableCell align="center">
                              <Box>{HemathologyRef.wbc()}</Box>
                            </TableCell>
                            <TableCell>
                              <Button
                                disabled={Boolean(parseInt(data.is_processed))}
                                size="small"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  setProcessDialog({
                                    data: data,
                                    open: true,
                                  });
                                }}
                              >
                                Process
                              </Button>
                            </TableCell>
                          </TableRow>

                          <TableRow
                            hidden={
                              !Boolean(data.platelet_count === "new-order")
                            }
                          >
                            <TableCell>
                              <Typography
                                variant="subtitle2"
                                className={`gtc-uppercase`}
                              >
                                Platelet count
                              </Typography>
                            </TableCell>
                            <TableCell align="center">
                              <Box>
                                <TextField
                                  margin="dense"
                                  // required
                                  fullWidth
                                  name="platelet_count[]"
                                  label="Result"
                                  type="number"
                                  InputProps={{
                                    inputProps: {
                                      min: 1,
                                      max: 1000,
                                      step: 0.01,
                                    },
                                  }}
                                  disabled={
                                    !Boolean(parseInt(data.is_processed))
                                  }
                                />
                              </Box>
                            </TableCell>
                            <TableCell align="center">
                              <Box>{HemathologyRef.plateletCount()}</Box>
                            </TableCell>
                            <TableCell>
                              <Button
                                disabled={Boolean(parseInt(data.is_processed))}
                                size="small"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  setProcessDialog({
                                    data: data,
                                    open: true,
                                  });
                                }}
                              >
                                Process
                              </Button>
                            </TableCell>
                          </TableRow>

                          <TableRow
                            hidden={
                              !Boolean(data.differential_count === "new-order")
                            }
                          >
                            <TableCell>
                              <Typography
                                variant="subtitle2"
                                className={`gtc-uppercase`}
                              >
                                differential count
                              </Typography>
                            </TableCell>
                            <TableCell align="center">
                              <Box>
                                <TextField
                                  margin="dense"
                                  // required
                                  fullWidth
                                  name="differential_count[]"
                                  label="Result"
                                  multiline
                                  disabled={
                                    !Boolean(parseInt(data.is_processed))
                                  }
                                />
                              </Box>
                            </TableCell>
                            <TableCell align="center"> </TableCell>
                            <TableCell>
                              <Button
                                disabled={Boolean(parseInt(data.is_processed))}
                                size="small"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  setProcessDialog({
                                    data: data,
                                    open: true,
                                  });
                                }}
                              >
                                Process
                              </Button>
                            </TableCell>
                          </TableRow>

                          <TableRow
                            hidden={!Boolean(data.neutrophil === "new-order")}
                          >
                            <TableCell>
                              <Typography
                                variant="subtitle2"
                                className={`gtc-uppercase`}
                              >
                                neutrophil
                              </Typography>
                            </TableCell>
                            <TableCell align="center">
                              <Box>
                                <TextField
                                  margin="dense"
                                  // required
                                  fullWidth
                                  name="neutrophil[]"
                                  label="Result"
                                  type="number"
                                  InputProps={{
                                    inputProps: {
                                      min: 0.01,
                                      max: 1000,
                                      step: 0.01,
                                    },
                                  }}
                                  disabled={
                                    !Boolean(parseInt(data.is_processed))
                                  }
                                />
                              </Box>
                            </TableCell>
                            <TableCell align="center">
                              <Box>{HemathologyRef.neutrophil()}</Box>
                            </TableCell>
                            <TableCell>
                              <Button
                                disabled={Boolean(parseInt(data.is_processed))}
                                size="small"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  setProcessDialog({
                                    data: data,
                                    open: true,
                                  });
                                }}
                              >
                                Process
                              </Button>
                            </TableCell>
                          </TableRow>

                          <TableRow
                            hidden={!Boolean(data.lymphocyte === "new-order")}
                          >
                            <TableCell>
                              <Typography
                                variant="subtitle2"
                                className={`gtc-uppercase`}
                              >
                                lymphocyte
                              </Typography>
                            </TableCell>
                            <TableCell align="center">
                              <Box>
                                <TextField
                                  margin="dense"
                                  // required
                                  fullWidth
                                  name="lymphocyte[]"
                                  label="Result"
                                  type="number"
                                  InputProps={{
                                    inputProps: {
                                      min: 0.01,
                                      max: 1000,
                                      step: 0.01,
                                    },
                                  }}
                                  disabled={
                                    !Boolean(parseInt(data.is_processed))
                                  }
                                />
                              </Box>
                            </TableCell>
                            <TableCell align="center">
                              <Box>{HemathologyRef.lymphocyte()}</Box>
                            </TableCell>
                            <TableCell>
                              <Button
                                disabled={Boolean(parseInt(data.is_processed))}
                                size="small"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  setProcessDialog({
                                    data: data,
                                    open: true,
                                  });
                                }}
                              >
                                Process
                              </Button>
                            </TableCell>
                          </TableRow>

                          <TableRow
                            hidden={!Boolean(data.monocyte === "new-order")}
                          >
                            <TableCell>
                              <Typography
                                variant="subtitle2"
                                className={`gtc-uppercase`}
                              >
                                monocyte
                              </Typography>
                            </TableCell>
                            <TableCell align="center">
                              <Box>
                                <TextField
                                  margin="dense"
                                  // required
                                  fullWidth
                                  name="monocyte[]"
                                  label="Result"
                                  type="number"
                                  InputProps={{
                                    inputProps: {
                                      min: 0.01,
                                      max: 1000,
                                      step: 0.01,
                                    },
                                  }}
                                  disabled={
                                    !Boolean(parseInt(data.is_processed))
                                  }
                                />
                              </Box>
                            </TableCell>
                            <TableCell align="center">
                              <Box>{HemathologyRef.monocyte()}</Box>
                            </TableCell>
                            <TableCell>
                              <Button
                                disabled={Boolean(parseInt(data.is_processed))}
                                size="small"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  setProcessDialog({
                                    data: data,
                                    open: true,
                                  });
                                }}
                              >
                                Process
                              </Button>
                            </TableCell>
                          </TableRow>

                          <TableRow
                            hidden={!Boolean(data.eosinophil === "new-order")}
                          >
                            <TableCell>
                              <Typography
                                variant="subtitle2"
                                className={`gtc-uppercase`}
                              >
                                eosinophil
                              </Typography>
                            </TableCell>
                            <TableCell align="center">
                              <Box>
                                <TextField
                                  margin="dense"
                                  // required
                                  fullWidth
                                  name="eosinophil[]"
                                  label="Result"
                                  type="number"
                                  InputProps={{
                                    inputProps: {
                                      min: 0.01,
                                      max: 1000,
                                      step: 0.01,
                                    },
                                  }}
                                  disabled={
                                    !Boolean(parseInt(data.is_processed))
                                  }
                                />
                              </Box>
                            </TableCell>
                            <TableCell align="center">
                              <Box>{HemathologyRef.eosinophil()}</Box>
                            </TableCell>
                            <TableCell>
                              <Button
                                disabled={Boolean(parseInt(data.is_processed))}
                                size="small"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  setProcessDialog({
                                    data: data,
                                    open: true,
                                  });
                                }}
                              >
                                Process
                              </Button>
                            </TableCell>
                          </TableRow>

                          <TableRow
                            hidden={!Boolean(data.basophil === "new-order")}
                          >
                            <TableCell>
                              <Typography
                                variant="subtitle2"
                                className={`gtc-uppercase`}
                              >
                                basophil
                              </Typography>
                            </TableCell>
                            <TableCell align="center">
                              <Box>
                                <TextField
                                  margin="dense"
                                  // required
                                  fullWidth
                                  name="basophil[]"
                                  label="Result"
                                  type="number"
                                  InputProps={{
                                    inputProps: {
                                      min: 0.01,
                                      max: 1000,
                                      step: 0.01,
                                    },
                                  }}
                                  disabled={
                                    !Boolean(parseInt(data.is_processed))
                                  }
                                />
                              </Box>
                            </TableCell>
                            <TableCell align="center">
                              <Box>{HemathologyRef.basophil()}</Box>
                            </TableCell>
                            <TableCell>
                              <Button
                                disabled={Boolean(parseInt(data.is_processed))}
                                size="small"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  setProcessDialog({
                                    data: data,
                                    open: true,
                                  });
                                }}
                              >
                                Process
                              </Button>
                            </TableCell>
                          </TableRow>

                          <TableRow
                            hidden={!Boolean(data.bands === "new-order")}
                          >
                            <TableCell>
                              <Typography
                                variant="subtitle2"
                                className={`gtc-uppercase`}
                              >
                                bands
                              </Typography>
                            </TableCell>
                            <TableCell align="center">
                              <Box>
                                <TextField
                                  margin="dense"
                                  // required
                                  fullWidth
                                  name="bands[]"
                                  label="Result"
                                  type="number"
                                  InputProps={{
                                    inputProps: {
                                      min: 0.01,
                                      max: 1000,
                                      step: 0.01,
                                    },
                                  }}
                                  disabled={
                                    !Boolean(parseInt(data.is_processed))
                                  }
                                />
                              </Box>
                            </TableCell>
                            <TableCell align="center">
                              <Box>{HemathologyRef.bands()}</Box>
                            </TableCell>
                            <TableCell>
                              <Button
                                disabled={Boolean(parseInt(data.is_processed))}
                                size="small"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  setProcessDialog({
                                    data: data,
                                    open: true,
                                  });
                                }}
                              >
                                Process
                              </Button>
                            </TableCell>
                          </TableRow>

                          <TableRow
                            hidden={
                              !Boolean(
                                data.abo_blood_type_and_rh_type === "new-order"
                              )
                            }
                          >
                            <TableCell>
                              <Typography
                                variant="subtitle2"
                                className={`gtc-uppercase`}
                              >
                                ABO blood type / rh type
                              </Typography>
                            </TableCell>
                            <TableCell align="center">
                              <Box>
                                <TextField
                                  margin="dense"
                                  // required
                                  fullWidth
                                  name="abo_blood_type_and_rh_type[]"
                                  label="Result"
                                  multiline
                                  disabled={
                                    !Boolean(parseInt(data.is_processed))
                                  }
                                />
                              </Box>
                            </TableCell>
                            <TableCell align="center"> </TableCell>
                            <TableCell>
                              <Button
                                disabled={Boolean(parseInt(data.is_processed))}
                                size="small"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  setProcessDialog({
                                    data: data,
                                    open: true,
                                  });
                                }}
                              >
                                Process
                              </Button>
                            </TableCell>
                          </TableRow>

                          <TableRow
                            hidden={
                              !Boolean(data.bleeding_time === "new-order")
                            }
                          >
                            <TableCell>
                              <Typography
                                variant="subtitle2"
                                className={`gtc-uppercase`}
                              >
                                bleeding time
                              </Typography>
                            </TableCell>
                            <TableCell align="center">
                              <Box>
                                <TextField
                                  margin="dense"
                                  // required
                                  fullWidth
                                  name="bleeding_time[]"
                                  label="Result"
                                  multiline
                                  disabled={
                                    !Boolean(parseInt(data.is_processed))
                                  }
                                />
                              </Box>
                            </TableCell>
                            <TableCell align="center">
                              <Box>{HemathologyRef.bleedingTime()} </Box>
                            </TableCell>
                            <TableCell>
                              <Button
                                disabled={Boolean(parseInt(data.is_processed))}
                                size="small"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  setProcessDialog({
                                    data: data,
                                    open: true,
                                  });
                                }}
                              >
                                Process
                              </Button>
                            </TableCell>
                          </TableRow>

                          <TableRow
                            hidden={
                              !Boolean(data.clotting_time === "new-order")
                            }
                          >
                            <TableCell>
                              <Typography
                                variant="subtitle2"
                                className={`gtc-uppercase`}
                              >
                                clotting time
                              </Typography>
                            </TableCell>
                            <TableCell align="center">
                              <Box>
                                <TextField
                                  margin="dense"
                                  // required
                                  fullWidth
                                  name="clotting_time[]"
                                  label="Result"
                                  multiline
                                  disabled={
                                    !Boolean(parseInt(data.is_processed))
                                  }
                                />
                              </Box>
                            </TableCell>
                            <TableCell align="center">
                              <Box>{HemathologyRef.clottingTime()}</Box>
                            </TableCell>
                            <TableCell>
                              <Button
                                disabled={Boolean(parseInt(data.is_processed))}
                                size="small"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  setProcessDialog({
                                    data: data,
                                    open: true,
                                  });
                                }}
                              >
                                Process
                              </Button>
                            </TableCell>
                          </TableRow>

                          <TableRow
                            hidden={
                              !Boolean(
                                data.blood_typing_with_rh === "new-order"
                              )
                            }
                          >
                            <TableCell>
                              <Typography
                                variant="subtitle2"
                                className={`gtc-uppercase`}
                              >
                                BLOOD TYPING
                              </Typography>
                            </TableCell>
                            <TableCell align="center" colSpan={2}>
                              <Box>
                                <TextField
                                  margin="dense"
                                  // required
                                  fullWidth
                                  name="blood_typing_with_rh[]"
                                  label="Result"
                                  multiline
                                  disabled={
                                    !Boolean(parseInt(data.is_processed))
                                  }
                                />
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Button
                                disabled={Boolean(parseInt(data.is_processed))}
                                size="small"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  setProcessDialog({
                                    data: data,
                                    open: true,
                                  });
                                }}
                              >
                                Process
                              </Button>
                            </TableCell>
                          </TableRow>
                        </Fragment>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell align="center" colSpan={4}>
                          <Typography color="secondary">
                            No record found.
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={4}>
                        <Typography color="primary">please wait...</Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
          <Box display="flex" m={1}>
            <Box flexGrow={1} />
            <Box>
              <CardActions>
                <Button
                  variant="contained"
                  size="large"
                  color="primary"
                  type="submit"
                  // hidden
                  ref={saveButtonRef}
                  disabled={!confirmDialog}
                >
                  Save Result Button
                </Button>

                <Button
                  variant="contained"
                  size="large"
                  color="primary"
                  onClick={() => setConfirmDialog(true)}
                  disabled={savebtnDisabled}
                >
                  Save Result
                </Button>
              </CardActions>
            </Box>
          </Box>
        </Card>
      </form>

      {/* set as pending dialog */}
      <Dialog
        open={pendingDialog}
        onClose={() => setPendingDialog(false)}
        disableBackdropClick
        PaperComponent={DraggableDialog}
      >
        <DialogTitle id="draggable-handle">Set as pending</DialogTitle>
        <form onSubmit={handlePendingOrder}>
          <DialogContent dividers>
            <Box mb={2}>
              <TextField
                rows={5}
                fullWidth
                name="reason"
                label={`Pending Reason`}
                variant="outlined"
                multiline
              />
            </Box>

            <Box>
              <TextField
                fullWidth
                name="password"
                label={`Password`}
                variant="outlined"
                type="password"
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="default"
              onClick={() => setPendingDialog(false)}
              startIcon={<HighlightOffIcon />}
            >
              cancel
            </Button>
            <Button
              variant="contained"
              color="secondary"
              type="submit"
              disabled={pendingSubmitting}
              startIcon={
                pendingSubmitting ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <ErrorOutlineIcon />
                )
              }
            >
              pending
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      {/* set as process dialog */}
      <Dialog
        open={processDialog.open}
        onClose={() => setProcessDialog({ open: false, data: null })}
        disableBackdropClick
        PaperComponent={DraggableDialog}
      >
        <DialogTitle id="draggable-handle">Set as processing</DialogTitle>
        <form onSubmit={handleProcessOrder}>
          <DialogContent dividers>
            <Box>
              <TextField
                fullWidth
                name="password"
                label={`Password`}
                variant="outlined"
                type="password"
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="default"
              onClick={() => setProcessDialog({ open: false, data: null })}
              startIcon={<HighlightOffIcon />}
            >
              no
            </Button>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              disabled={processSubmitting}
              startIcon={
                processSubmitting ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <CheckCircleIcon />
                )
              }
            >
              process
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      {/* confirmation dialog */}
      <Dialog open={confirmDialog} onClose={() => setConfirmDialog(false)}>
        <DialogContent>
          <Typography>Are you sure to continue and save result?</Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="default"
            startIcon={<XCircle />}
            onClick={() => setConfirmDialog(false)}
          >
            No
          </Button>
          <Button
            variant="contained"
            color="primary"
            disabled={resultSubmitting}
            startIcon={
              resultSubmitting ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                <CheckSquare />
              )
            }
            onClick={() => saveButtonRef.current.click()}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default OrderDetails;
